<template>
  <ShareBtn
    v-ripple
    :class="isMobile ? 'rounded-15' : 'rounded-20'"
    url-name="lpu"
    type="lpu"
    :size="isMobile ? 36 : 52"
    :url="reverseFullL10N({
      name: 'lpu',
      args: {
        language: urlLang,
        town_translit: lpu.town.translit,
        lpu_translit: lpu.translit,
      },
    })"
  />
</template>

<script lang="ts" setup>
import useIsMobile from 'src/composables/useIsMobile'
import type { CommonContextStore } from 'src/types/context'
import useContextStore from 'src/store/useContextStore'
import useURLStore from 'src/store/useURLStore'
import ShareBtn from 'src/components/common/ShareBtn/ShareBtn.vue'
import type { Lpu } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_types'

defineProps<{
  lpu: Lpu
}>()

const isMobile = useIsMobile()

const { urlLang }: CommonContextStore = useContextStore()
const { reverseFullL10N } = useURLStore()
</script>
